<template>
  <div>
    <wc-dialog
      :showDialog='showDialog'
      title='New User'
      :icon='toolbarData.icon'
      @cancel="$emit('cancel')"
      @save='createAccount'
      width='400'
      :disableButtons='!isFormValid || !username_is_available || checkingUsername'
      :loadingButtons='isCreating'
      saveText='Create User'
    >
      <v-form v-model='isFormValid' ref='form'>
        <v-text-field
          label='First name'
          v-model='account.first_name'
          :rules='[rules.required]'
        ></v-text-field>
        <v-text-field
          label='Last name'
          :rules='[rules.required]'
          v-model='account.last_name'
        ></v-text-field>
        <v-text-field
          label='Email'
          v-model='account.email'
          :rules='[rules.emailRequired]'
        ></v-text-field>
        <v-text-field
          label='Username'
          hint='All lower case, no spaces, letters and numbers only'
          v-model='account.username'
          :rules='[rules.usernameSpec, rules.required]'
        ></v-text-field>
        <div v-if='checkingUsername'>
          <wc-loading line></wc-loading>
        </div>
        <div v-if='!username_is_available && account.username'>
          <v-icon color='error' left>mdi-close</v-icon> Username is not available
        </div>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import formRules from '@/mixins/formRules'
import staffingAPI from '../../api/staffing'
import _ from 'lodash'

export default {
  name: 'add-user',
  mixins: [formRules],
  props: {
    showDialog: {
      required: true
    }
  },
  data: () => ({
    isCreating: false,
    isFormValid: false,
    isLoading: false,
    checkingUsername: false,
    username_is_available: false,
    account: {
      email: null,
      first_name: '',
      last_name: '',
      username: '',
      password: 'nothing',
      password2: 'nothing'
    }
  }),
  watch: {
    showDialog () {
      if (this.showDialog) {
        this.resetAccount()
        this.checkingUsername = false
      }
    },
    'account.username' () {
      if (this.account.username !== '' && this.account.username !== undefined) {
        this.checkingUsername = true
        this.checkUsernameAvailability()
      }
    }
  },
  computed: {
    toolbarData () {
      return this.$store.state.icons.modules.profile
    }
  },
  methods: {
    async createAccount () {
      this.isCreating = true
      this.account.username = _.toLower(this.account.username)
      let newUser = await staffingAPI.createUser(this.account)
      let userProfile = await staffingAPI.getUserProfile(newUser.id)
      staffingAPI.emailNewUser(newUser.id)
      this.$emit('save', userProfile)
      this.isCreating = false
    },
    async checkUsername () {
      this.username_is_available = await staffingAPI.isUsernameAvailable(this.account.username)
      this.checkingUsername = false
    },
    checkUsernameAvailability: _.debounce(function () {
      this.checkingUsername = true
      this.checkUsername()
    }, 1000),
    resetAccount () {
      this.account.email = null
      this.account.first_name = ''
      this.account.last_name = ''
      this.account.username = ''
      this.account.password = 'nothing'
      this.account.password2 = 'nothing'
      this.username_is_available = true
      setTimeout(() => {
        this.$refs.form.reset()
      }, 50)
    }
  }
}
</script>
